import { render, staticRenderFns } from "./presentation-editor-reorder.vue?vue&type=template&id=5b52f8a5&scoped=true&"
import script from "./presentation-editor-reorder.vue?vue&type=script&lang=js&"
export * from "./presentation-editor-reorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b52f8a5",
  null
  
)

export default component.exports